/* eslint-disable */
import axios from 'axios'
import $ from 'jquery'

function checkStringIsUrl(str) {

  if (str) {
    var regexp = /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/
    return regexp.test(str);
  }
}

function htmlEntities(str) {
  // &(?!(nbsp;)) string that contain & and not follow by nbsp;
  return String(str).replace(/&(?!(nbsp;))/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}

export default {
  async get_chat_logs(senderId, senderToken, botCode, urlLoad = '') {
    let return_data = []
    // console.log(senderId)
    // console.log(botCode)
    let api_url_msg_server = process.env.VUE_APP_API_URL_MSG_SERVER
    // console.log(api_url_msg_server)
    let default_params = 'bot/' + botCode + '/get-chatlog/' + encodeURI(senderId) + '/'
    let url = api_url_msg_server + (urlLoad === '' ? default_params : urlLoad.replace('/backend/api/v1/', '')) // TODO-replace fix when change URI request

    let sendHeaders = {
      headers: {
        "Authorization": "Bearer " + senderToken
      }
    }

    await axios.get(url, sendHeaders).then(response => {
      // console.log(response.data)
      return_data = response.data

    }).catch(e => {
      console.log(e.response)
    })

    return return_data
  },

  async get_suggestion_list(senderId, senderToken, botCode, urlLoad = '') {
    let return_data = []
    let api_url_msg_server = process.env.VUE_APP_API_URL_MSG_SERVER
    // console.log(api_url_msg_server)
    let default_params = 'bot/' + botCode + '/' + encodeURI(senderId) + '/get-list-suggestion/'
    let url = api_url_msg_server + (urlLoad === '' ? default_params : urlLoad.replace('/backend/api/v1/', ''))

    let sendHeaders = {
      headers: {
        "Authorization": "Bearer " + senderToken
      }
    }

    await axios.get(url, sendHeaders).then(response => {
      // console.log(response.data)
      return_data = response.data

    }).catch(e => {
      console.log(e.response)
    })

    return return_data

  },

  async is_chat_with_bot(senderId, senderToken, botCode, urlLoad = '') {
    let result = false
    let api_url_msg_server = process.env.VUE_APP_API_URL_MSG_SERVER
    // console.log(api_url_msg_server)
    let default_params = 'bot/' + botCode + '/' + encodeURI(senderId) + '/is-chat-with-bot/'
    let url = api_url_msg_server + (urlLoad === '' ? default_params : urlLoad.replace('/backend/api/v1/', ''))

    let sendHeaders = {
      headers: {
        "Authorization": "Bearer " + senderToken
      }
    }

    await axios.get(url, sendHeaders).then(response => {
      // console.log(response.data)
      result = response.data

    }).catch(e => {
      console.log(e.response)
    })

    return result

  },

  async get_persistent_menus(botCode) {
    let return_data = null

    let url = process.env.VUE_APP_API_URL_MSG_SERVER + "bot/" + botCode + "/get-persistent-menu/"
    await axios.get(url).then(response => {
      // console.log(response.data)
      return_data = response.data

    }).catch(e => {
      console.log(e.response)
    })

    return return_data
  },

  guid() {
    return (
      this.s4() +
      this.s4() +
      "-" +
      this.s4() +
      "-" +
      this.s4() +
      "-" +
      this.s4() +
      "-" +
      this.s4() +
      this.s4() +
      this.s4()
    );
  },

  s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  },

  clickOpenLink(urls) {
    $("#ctr_link")[0].href = urls
    $("#ctr_link")[0].click()
  },

  clickCallPhone(phoneNumber) {
    $("#ctr_phone")[0].href = "tel:" + phoneNumber
    $("#ctr_phone")[0].click()
  },

  linkify(text) {
    var urlRegex = /[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/ig
    return text.replace(urlRegex, function (url) {
      return '<a href="' + url + '" target="blank" class="white--text">' + url + '</a>'
    })
  },

  urlify(text) {
    text = htmlEntities(text)
    if (checkStringIsUrl(text)) {
      var urlRegex = /(https?:\/\/[^\s]+)/g;
      return text.replace(urlRegex, function (url) {
        return '<a rel="noopener" style="position: relative; display: block; width: 100%; word-break: break-all;" target="_blank" href="' + url + '">' + (url) + '</a>';
      });
    } else {
      return text;
    }

  },

  getClientInfo (botCode) {
    return JSON.parse(
      localStorage.getItem("fptai_livechat_client_" + botCode)
    );
  },

  b64EncodeUnicode(str) {
    return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g,
        function toSolidBytes(match, p1) {
          return String.fromCharCode('0x' + p1);
        }));
  },
  b64DecodeUnicode(str) {
    return decodeURIComponent(atob(str).split('').map(function (c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
  }




}